import {call, put, takeLeading} from 'redux-saga/effects'

import {
  GET_ORDERS,
  getOrdersSuccess,
  getOrdersFailure,
  getOrdersPending,
} from '../actions/postCheckout'

import {isGoodResponse} from '../api/statusCodes'

import * as api from '../api/api'

// Get Post-Checkout Order Details
// ----------------------------------------------------------------------------

export function* getOrdersWorker({payload: {orderId}}) {
  try {
    yield put(getOrdersPending())
    const response = yield call(api.getOrders, orderId)

    if (isGoodResponse(response.status)) {
      yield put(getOrdersSuccess(response.json))
    } else {
      throw new Error(`Could not get orders: ${response.status}`)
    }
  } catch (e) {
    console.error('Could not get orders.', e.message)
    yield put(getOrdersFailure(e))
  }
}

export function* getOrdersSaga() {
  yield takeLeading(GET_ORDERS, getOrdersWorker)
}
